export enum HTTPMethods {
  DELETE = 'DELETE',
  GET = 'GET',
  PATCH = 'PATCH',
  POST = 'POST',
  PUT = 'PUT',
}

export interface APIEndpoint {
  key?: string;
  path: string;
  method: string;
  pathParams?: string[];
  queryParams?: string[];
}

export interface RequestInput {
  body?: any;
  pathParams?: { [name: string]: string };
  queryParams?: { [name: string]: string };
}

export type Query = {
  key: string[];
  endpoint: APIEndpoint;
};

export enum Api {
  AlgoInputs = 'AlgoInputs',
  RunAlgo = 'RunAlgo',
  Analytes = 'Analytes',
  DnaCategoryResults = 'DnaCategoryResults',
  Hormones = 'Hormones',
  Me = 'Me',
  Nutrients = 'Nutrients',
  Quiz = 'Quiz',
  SubmitQuizResponse = 'SubmitQuizResponse',
  UserRequest = 'UserRequest',
}
